// extracted by mini-css-extract-plugin
export var callCard = "_ne-0";
export var callMessageButton = "_ne-1";
export var helpIcon = "_ne-3";
export var helpIconContainer = "_ne-4";
export var verticalDivider = "_ne-2";